import * as React from 'react';
import { SVGProps } from 'react';

const IconLineAndBarChartSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m7.873 3.713-3-2-3.58 3.58 1.414 1.414 2.42-2.42 3 2 2.765-2.765L13.2 6.6l1.6-1.2L11.108.478 7.873 3.713ZM4 8v7h2V8H4Zm-3 3v4h2v-4H1Zm6-1v5h2v-5H7Zm3-2v7h2V8h-2Zm3 3v4h2v-4h-2Z" />
  </svg>
);
export default IconLineAndBarChartSizeS;
